import axios from '@/libs/axios'

export default {
  // Lead history
  getLeadHistoryPerPage({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'lead-history/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_LEAD_HISTORY_PER_PAGE', res.data.results)
          commit('SET_LEAD_HISTORY_TOTAL_COUNT', res.data.count)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  getLeadHistoryByLeadIdPerPage({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `lead/${params.id}/history`,
        method: 'GET',
        params: params.queryParams
      })
        .then(res => {
          commit('SET_LEAD_HISTORY_BY_LEAD_ID_PER_PAGE', res.data.results)
          commit('SET_LEAD_HISTORY_BY_LEAD_ID_TOTAL_COUNT', res.data.count)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  addLeadHistoryItem({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `lead-history/`,
        method: 'POST',
        data: params
      })
        .then(res => {
          commit('ADD_LEAD_HISTORY_ITEM', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  editLeadHistoryItem({commit}, item) {
    return new Promise((resolve, reject) => {
      axios({
        url: `lead-history/${item.id}/`,
        method: 'PATCH',
        data: item
      })
        .then(res => {
          commit('EDIT_LEAD_HISTORY_ITEM', res.data)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  deleteLeadHistoryItem({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `lead-history/${id}/`,
        method: 'DELETE'
      })
        .then(res => {
          commit('DELETE_LEAD_HISTORY_ITEM', id)
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  // Lead
  fetchLeads({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'lead/',
        method: 'GET',
        params: params.queryParams
      })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  getLead({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `lead/${id}/`,
        method: 'GET'
      })
        .then(res => resolve(res))
        .catch(error => reject({message: error}))
    })
  },
  addLead({commit}, item) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'lead/',
        method: 'POST',
        data: item
      })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  editLead({commit}, item) {
    return new Promise((resolve, reject) => {
      axios({
        url: `lead/${item.id}/`,
        method: 'PATCH',
        data: item
      })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject({message: error})
        })
    })
  },
  createPatientFromLead({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'lead-to-patient/', method: 'POST', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  // Lead history statuses
  fetchLeadHistoryStatuses({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `lead-history-status/`,
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_LEAD_HISTORY_STATUS', res.data)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  // UTM-sources
  getUtmSourcePerPage({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'advertising-platform-utm-source/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_UTM_SOURCES_PER_PAGE', res.data.results)
          commit('SET_UTM_SOURCES_PER_PAGE_COUNT', res.data.count)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  addUtmSource({commit}, item) {
    return new Promise((resolve, reject) => {
      axios.post('advertising-platform-utm-source/', item)
        .then(res => {
          commit('ADD_UTM_SOURCE', res.data)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  editUtmSource({commit}, item) {
    return new Promise((resolve, reject) => {
      axios.patch(`advertising-platform-utm-source/${item.id}/`, item)
        .then(res => {
          commit('EDIT_UTM_SOURCE', res.data)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  removeUtmSource({commit}, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`advertising-platform-utm-source/${id}/`)
        .then(res => {
          commit('REMOVE_UTM_SOURCE', id)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  // UTM-mediums
  getUtmMediumPerPage({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'advertising-platform-utm-medium/',
        method: 'GET',
        params: params
      })
        .then(res => {
          commit('SET_UTM_MEDIUMS_PER_PAGE', res.data.results)
          commit('SET_UTM_MEDIUMS_PER_PAGE_COUNT', res.data.count)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  addUtmMedium({commit}, item) {
    return new Promise((resolve, reject) => {
      axios.post('advertising-platform-utm-medium/', item)
        .then(res => {
          commit('ADD_UTM_MEDIUM', res.data)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  editUtmMedium({commit}, item) {
    return new Promise((resolve, reject) => {
      axios.patch(`advertising-platform-utm-medium/${item.id}/`, item)
        .then(res => {
          commit('EDIT_UTM_MEDIUM', res.data)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
  removeUtmMedium({commit}, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`advertising-platform-utm-medium/${id}/`)
        .then(res => {
          commit('REMOVE_UTM_MEDIUM', id)
          resolve(res)
        })
        .catch(error => reject({message: error}))
    })
  },
}
